import Vue from 'vue'
import Vuex from 'vuex'

import { storage_key } from '@/config/constant'
import langs from '@/config/lang'


Vue.use(Vuex)


const store = new Vuex.Store({
  state: {
    // 语言配置
    langs: {
      ...langs
    },
    // 当前使用语言
    activeLang: localStorage.getItem(storage_key.lang) ? localStorage.getItem(storage_key.lang) : ''
  },


  getters: {
    // 获取当前系统语言。默认为中文
    currentLang: (state) => {
      if (state.activeLang && state.langs[state.activeLang]) {
        return state.langs[state.activeLang]
      }
      else {
        const systemLanguage = window.navigator.language
        const systemLanguages = window.navigator.languages
        const languageLis = ['zh-CN', 'zh-cn', 'ZH-CN', 'ZH-cn', 'zh', 'cn', 'CN', 'ZH']

        /* console.log('window.navigator', window.navigator)
        console.log('systemLanguage', systemLanguage)
        console.log('systemLanguages', systemLanguages) */
        
        if (languageLis.includes(systemLanguage)) {
          return state.langs['zh-CN']
        }
        else {
          return state.langs['en']
        }
      }
    }
  },


  mutations: {
    changeLang(state, payload) {
      state.activeLang = payload
      localStorage.setItem(storage_key.lang, payload)
      window.location.reload()
    }
  },


  actions: {
    
  }
})


export default store


// WEBPACK FOOTER //
// ./src/stores/index.js